import { Component } from '@opten/compiler/metadata/component';
import { OnInit } from '@opten/compiler/metadata/lifecycle';
import { changeClass } from '@opten/dom/change-class';

@Component({ className: 'js-form-field', observe: true })
export class FormField implements OnInit {
	constructor(private element: HTMLInputElement | HTMLSelectElement) {}

	onInit(): void {
		this.checkValue();
		this.element.addEventListener('input', () => this.checkValue());
		this.element.addEventListener('change', () => this.checkValue());
	}

	private checkValue() {
		changeClass(this.element, 'is-filled', !!this.element.value);
	}
}
